/**
 * @generated SignedSource<<ae9fd3b1fc50f07faf4b22ab523e5f59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NewEventDetailBody$data = {
  readonly description: string | null | undefined;
  readonly eventSeries: {
    readonly image: {
      readonly publicId: string;
    } | null | undefined;
  };
  readonly eventSessions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"EventDateTimeLocationBar_eventSession" | "EventDetailHosts">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailCapacity_event" | "EventDetailMultiSessionDateDisplay_event" | "EventDetailPairings_event" | "EventDetailSeriesNavButtons_event" | "EventDetailTitleRow">;
  readonly " $fragmentType": "NewEventDetailBody";
};
export type NewEventDetailBody$key = {
  readonly " $data"?: NewEventDetailBody$data;
  readonly " $fragmentSpreads": FragmentRefs<"NewEventDetailBody">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewEventDetailBody",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailSeriesNavButtons_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailPairings_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailTitleRow"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailMultiSessionDateDisplay_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailCapacity_event"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "EventSessionConnection",
      "kind": "LinkedField",
      "name": "eventSessions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSessionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSession",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EventDateTimeLocationBar_eventSession"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EventDetailHosts"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "eventSessions(first:1000)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            {
              "alias": "publicId",
              "args": null,
              "kind": "ScalarField",
              "name": "renderingKey",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "4bafd6ef1616e4e3552176c1defaf471";

export default node;
